// Canonical app routes for a title.
//
// A title belongs to a project, so its canonical URL is nested under one — which also means the
// create page gets its project from the route rather than from navigation state (state does not
// survive a refresh or a hand-edited URL).
//
// The flat `/title/:id` form still resolves, for bookmarks made before the nested routes existed
// and for callers that only know the title id (e.g. a calendar event).

export const newTitlePath = (projectID) => `/project/${projectID}/title`;

export const titlePath = (titleID, projectID) => (projectID ? `/project/${projectID}/title/${titleID}` : `/title/${titleID}`);

export default titlePath;
